const PaxsHotel = (state) => state.PaxsHotel

export default {
  PaxsHotel
}
